import { render } from "./Goods.vue?vue&type=template&id=01c1e60a&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=01c1e60a&scoped=true&lang=less"

import exportComponent from "D:\\case\\追溯平台\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c1e60a"]])

export default __exports__